import type { Proposal } from '@/domain/types';

import type { DecisionOutcome } from './dialogs';

/** A 409 recorded at page level: the proposal as the person saw it, and as it now stands. */
export interface Conflict {
  before: Proposal;
  current: Proposal;
  displayName: string;
}

/** Turn a decision outcome into a page-level conflict record, or null for anything else. */
export function conflictOf(
  outcome: DecisionOutcome,
  before: Proposal,
  displayName: string,
): Conflict | null {
  return outcome.kind === 'conflict' ? { before, current: outcome.current, displayName } : null;
}
